import { useTunnusContext } from 'contexts/TunnusContext';
import { useCallback, useEffect, useState } from 'react';
import { apmRum } from 'services/apm-rum';
import logger from 'services/logger';

export function useBrazeToken(): {
  token: string | null;
  refreshToken: () => void;
} {
  const { user: { userId } = {}, yleTunnusInstance } = useTunnusContext();
  const isBrazeAllowed = !!userId;

  const [token, setToken] = useState<string | null>(null);

  const refreshToken = useCallback(() => {
    if (!isBrazeAllowed || !yleTunnusInstance) return;
    yleTunnusInstance
      .getBrazeToken()
      .then(setToken)
      .catch((error: unknown) => {
        logger.error(error, 'Failed to get Braze token');
        if (error instanceof Error) apmRum?.captureError(error);
      });
  }, [isBrazeAllowed, yleTunnusInstance]);

  useEffect(() => {
    refreshToken();
  }, [refreshToken]);

  return { token, refreshToken };
}
